// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__33jVd","footer":"ChangeClinic_footer__17MQ6"};